import React, { useContext, useRef } from "react";
import classes from "./WhoCanChooseUs.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import { useLocation } from "react-router-dom";
import { NavigationContext } from "../../../App";
import ChooseCard from "./who-can-choose-card/ChooseCard";

const WhoCanChooseUs = ({ data }) => {
  const swiperRef = useRef(null);
  const width = useDeviceWidth();
  const { setIsBackNavigation } = useContext(NavigationContext);
  const location = useLocation();
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

  const repeatObjects = (arr, number = 4) => {
    if (!Array.isArray(arr) || arr.length === 0) return []; // Return empty array if invalid
    if (arr.length >= number) return arr; // If already 4 or more, return as is

    let repeatedArr = [...arr]; // Clone the original array

    while (repeatedArr.length < number) {
      repeatedArr = [...repeatedArr, ...arr]; // Repeat the original array
    }

    return repeatedArr.slice(0, Math.max(number, arr.length * 2)); // Ensure correct length
  };

  console.log("who can choose us", data);

  // Guard clause to prevent rendering Swiper if data.listingItems is invalid
  if (!data?.listingItems || !Array.isArray(data.listingItems)) {
    console.error("Invalid or missing data.listingItems:", data?.listingItems);
    return (
      <div className={`${classes.outer} bg-primary-100`}>
        <div className={classes.inner}>
          <img src="/img/foreign-pattern.svg" className={classes.pattern} alt="pattern"></img>
          <div className={classes.innerContent}>
            <div className={classes.title} data-aos="fade-down" data-aos-delay="200">
              <h1 className="bg-primary-200">{data?.subTitle}</h1>
              {data?.showTitle && (
                <div>
                  <h2 dangerouslySetInnerHTML={{ __html: data?.title }}></h2>
                </div>
              )}
            </div>
            <div className={classes.sliderOuter}>
              <p>No items available to display.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`${classes.outer} bg-primary-100`}>
      <div className={classes.inner}>
        <img src="/img/foreign-pattern.svg" className={classes.pattern} alt="pattern"></img>
        <div className={classes.innerContent}>
          <div className={classes.title} data-aos="fade-down" data-aos-delay="200">
            {data?.showTitle && (
              <div>
                <h2 dangerouslySetInnerHTML={{ __html: data?.title }}></h2>
              </div>
            )}
            <h1>{data?.subTitle}</h1>
          </div>
          <div className={classes.sliderOuter}>
            <div className={classes.arrowDiv}>
              <img
                src="/img/title-symbol.svg"
                className={classes.titleSymbol}
                alt="symbol"
              ></img>
              <div className={classes.arrows}>
                <img
                  className={classes.leftArrow}
                  src="/img/doctor-left.svg"
                  alt="Prev"
                  onClick={() => swiperRef.current?.slidePrev()} // Trigger previous slide
                />
                <img
                  src="/img/doctor-right.svg"
                  className={classes.rightArrow}
                  alt="Next"
                  onClick={() => swiperRef.current?.slideNext()} // Trigger next slide
                />
              </div>
            </div>
            <div className="outer-outer">
              <div>
                <Swiper
                  modules={[Autoplay]} // Include all required modules
                  slidesPerView={
                    width > 1800
                      ? 5
                      : width > 1200
                      ? 4
                      : width > 900
                      ? 3
                      : width > 550
                      ? 2
                      : 1
                  }
                  spaceBetween={20}
                  onSwiper={(swiper) => (swiperRef.current = swiper)}
                  pagination={{ clickable: true }}
                 // navigation={true} // Enable navigation for arrows
                  loop={true}
                  draggable={true}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                >
                  {repeatObjects(data.whoCanChooseUS, 6).map((slide) => (
                    <SwiperSlide key={slide.id}>
                      <ChooseCard data={slide} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhoCanChooseUs;